import React from "react";
import { FileUp, Brain, Rocket, Wallet } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: FileUp,
    title: "Upload your resume",
    body: "PDF, DOCX, or paste plain text. We parse roles, wins, tools and languages.",
    accent: "bg-blue-50 text-blue-700",
  },
  {
    n: "02",
    icon: Brain,
    title: "AI agent built from your skills",
    body: "GPT-5.2 sculpts a persona, service catalog, pricing, and a portfolio voice.",
    accent: "bg-sky-50 text-sky-700",
  },
  {
    n: "03",
    icon: Rocket,
    title: "Agent works 24/7",
    body: "It scopes briefs, replies to leads, drafts deliverables and books work — autonomously.",
    accent: "bg-indigo-50 text-indigo-700",
  },
  {
    n: "04",
    icon: Wallet,
    title: "You earn, every payout",
    body: "Approve milestones in one tap. Cash hits your account within 24 hours.",
    accent: "bg-emerald-50 text-emerald-700",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" data-testid="how-it-works" className="relative py-24">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-blue-600">How it works</p>
            <h2 className="mt-2 font-display text-3xl sm:text-4xl md:text-5xl font-black tracking-tight text-slate-900 max-w-2xl leading-tight">
              From resume to revenue in under{" "}
              <span className="text-blue-600">4 minutes</span>.
            </h2>
          </div>
          <p className="text-slate-600 max-w-md">
            No portfolio? No client list? No problem. Freelancity industrializes your career so it can sell itself.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {STEPS.map((s, i) => {
            // Alternate the bento span: first & last rows lead with the wide tile (7 cols),
            // second & third tiles take the narrow side (5 cols).
            const span = i === 1 || i === 2 ? "md:col-span-5" : "md:col-span-7";
            return (
            <div
              key={s.n}
              className={`group relative lift rounded-2xl bg-white border border-slate-200 p-6 ${span}`}
              data-testid={`how-step-${s.n}`}
            >
              <div className="flex items-start gap-4">
                <span className={`grid place-items-center w-12 h-12 rounded-xl ${s.accent}`}>
                  <s.icon size={22} />
                </span>
                <div>
                  <p className="font-mono text-xs text-slate-400">{s.n}</p>
                  <h3 className="font-display text-xl sm:text-2xl font-bold text-slate-900 mt-1">{s.title}</h3>
                  <p className="mt-2 text-slate-600 leading-relaxed">{s.body}</p>
                </div>
              </div>
              <div className="absolute right-6 bottom-4 opacity-0 group-hover:opacity-100 transition text-blue-600 text-sm font-medium">
                Try this step →
              </div>
            </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
